import axios from "axios";
import { logoutDispatcher } from "components/login/dispatcher";
import { decryptToken } from "./SecureToken";

//function to api calling
export const serverCall = async (
  url,
  method,
  dispatch,
  data = {},
  additionalHeader = {}
) => {
  try {
    const token = localStorage.getItem("authToken");
    let decryptedtoken;
    if (token) {
      decryptedtoken = decryptToken(token);
    }
    // Determine if the data is FormData
    const isFormData = data instanceof FormData;

    console.log(`isFormdata:${isFormData}`);

    const headers = {
      Authorization: `Bearer ${decryptedtoken}`,
      ...(isFormData ? "" : { "Content-Type": "application/json" }),
      ...additionalHeader,
    };

    const requestObject = {
      url,
      method,
      data,
      headers,
      maxBodyLength: Infinity,
    };
    console.log("Call server");
    const response = await axios.request(requestObject);

    // console.log(`response:${JSON.stringify(response, null, 2)}`);

    // if api calling success
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: "",
      };
    } else {
      return {
        success: false,
        data: {},
        message: "Unexpected response status",
      };
    }
  } catch (error) {
    //if error got token expired
    if (error?.response?.data?.error === "jwt expired") {
      if (dispatch) {
        dispatch(logoutDispatcher());
      }
      return {
        success: false,
        data: {},
        message:
          error.response?.data?.error || error.message || "Network error",
      };
    } else {
      console.log(`error:${JSON.stringify(error)}`);
       console.error("API Error Response:", error.response?.data); // Log full backend error
      return {
        success: false,
        data: {},
        message: (str => str.charAt(0).toUpperCase() + str.slice(1))(
          typeof error.response?.data?.error === 'string' ? error.response?.data?.error || error.message || "Network error" : error.response?.data?.message || error.message || "Network error"
        )
      };
    }
  }
};
